export const countriesData = {
  en: [
    { code: 'A', name: 'Austria' },
    { code: 'AL', name: 'Albania' },
    { code: 'AND', name: 'Andorra' },
    { code: 'B', name: 'Belgium' },
    { code: 'BG', name: 'Bulgaria' },
    { code: 'BIH', name: 'Bosnia and Herzegovina' },
    { code: 'BY', name: 'Belarus' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'CY', name: 'Cyprus' },
    { code: 'CZ', name: 'Czechia' },
    { code: 'D', name: 'Germany' },
    { code: 'DK', name: 'Denmark' },
    { code: 'E', name: 'Spain' },
    { code: 'EST', name: 'Estonia' },
    { code: 'F', name: 'France' },
    { code: 'FIN', name: 'Finland' },
    { code: 'FL', name: 'Liechtenstein' },
    { code: 'GR', name: 'Greece' },
    { code: 'H', name: 'Hungary' },
    { code: 'HR', name: 'Croatia' },
    { code: 'I', name: 'Italy' },
    { code: 'IRL', name: 'Ireland' },
    { code: 'IS', name: 'Iceland' },
    { code: 'L', name: 'Luxembourg' },
    { code: 'LT', name: 'Lithuania' },
    { code: 'LV', name: 'Latvia' },
    { code: 'M', name: 'Malta' },
    { code: 'MC', name: 'Monaco' },
    { code: 'MD', name: 'Moldova' },
    { code: 'MNE', name: 'Montenegro' },
    { code: 'N', name: 'Norway' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'NMK', name: 'North Macedonia' },
    { code: 'P', name: 'Portugal' },
    { code: 'PL', name: 'Poland' },
    { code: 'RKS', name: 'Kosovo' },
    { code: 'RO', name: 'Romania' },
    { code: 'RSM', name: 'San Marino' },
    { code: 'RUS', name: 'Russia' },
    { code: 'S', name: 'Sweden' },
    { code: 'SK', name: 'Slovakia' },
    { code: 'SLO', name: 'Slovenia' },
    { code: 'SRB', name: 'Serbia' },
    { code: 'TR', name: 'Turkey' },
    { code: 'UA', name: 'Ukraine' },
    { code: 'UK', name: 'United Kingdom' },
    { code: 'V', name: 'Vatican City' }
  ],
  
  fr: [
    { code: 'A', name: 'Autriche' },
    { code: 'AL', name: 'Albanie' },
    { code: 'AND', name: 'Andorre' },
    { code: 'B', name: 'Belgique' },
    { code: 'BG', name: 'Bulgarie' },
    { code: 'BIH', name: 'Bosnie-Herzégovine' },
    { code: 'BY', name: 'Biélorussie' },
    { code: 'CH', name: 'Suisse' },
    { code: 'CY', name: 'Chypre' },
    { code: 'CZ', name: 'Tchéquie' },
    { code: 'D', name: 'Allemagne' },
    { code: 'DK', name: 'Danemark' },
    { code: 'E', name: 'Espagne' },
    { code: 'EST', name: 'Estonie' },
    { code: 'F', name: 'France' },
    { code: 'FIN', name: 'Finlande' },
    { code: 'FL', name: 'Liechtenstein' },
    { code: 'GR', name: 'Grèce' },
    { code: 'H', name: 'Hongrie' },
    { code: 'HR', name: 'Croatie' },
    { code: 'I', name: 'Italie' },
    { code: 'IRL', name: 'Irlande' },
    { code: 'IS', name: 'Islande' },
    { code: 'L', name: 'Luxembourg' },
    { code: 'LT', name: 'Lituanie' },
    { code: 'LV', name: 'Lettonie' },
    { code: 'M', name: 'Malte' },
    { code: 'MC', name: 'Monaco' },
    { code: 'MD', name: 'Moldavie' },
    { code: 'MNE', name: 'Monténégro' },
    { code: 'N', name: 'Norvège' },
    { code: 'NL', name: 'Pays-Bas' },
    { code: 'NMK', name: 'Macédoine du Nord' },
    { code: 'P', name: 'Portugal' },
    { code: 'PL', name: 'Pologne' },
    { code: 'RKS', name: 'Kosovo' },
    { code: 'RO', name: 'Roumanie' },
    { code: 'RSM', name: 'Saint-Marin' },
    { code: 'RUS', name: 'Russie' },
    { code: 'S', name: 'Suède' },
    { code: 'SK', name: 'Slovaquie' },
    { code: 'SLO', name: 'Slovénie' },
    { code: 'SRB', name: 'Serbie' },
    { code: 'TR', name: 'Turquie' },
    { code: 'UA', name: 'Ukraine' },
    { code: 'UK', name: 'Royaume-Uni' },
    { code: 'V', name: 'Vatican' }
  ]
};

// For backward compatibility
export const countries = countriesData.en;